import React from 'react';
import { Code2, File, FileText } from 'lucide-react';

const ICONS = {
  code: Code2,
  document: FileText,
} as const;

/** Icon for an attached file's type; anything unrecognised gets a plain file. */
export function getFileIcon(type: string): React.ReactElement {
  const Icon = ICONS[type as keyof typeof ICONS] ?? File;
  return <Icon className="size-4" strokeWidth={1.9} />;
}
